// Add your custom JS here.
(function ($) {
	('use strict');

	// -----------------------------------------------------------------
	// Scroll to top button
	// -----------------------------------------------------------------

	window.addEventListener('scroll', function () {
		var scroll = $(this).scrollTop();

		if (scroll > 500) {
			// Scroll down
			$('.d--scroll-to-top').fadeIn();
		} else {
			// Scroll up
			$('.d--scroll-to-top').fadeOut();
		}
	});

	$(document).ready(function () {
		$('.d--scroll-to-top').click(function (e) {
			$('html, body').animate(
				{
					scrollTop: 0,
				},
				800
			);
			e.preventDefault();
			return false;
		});
	});

	// -----------------------------------------------------------------
	// Scroll to anchor
	// -----------------------------------------------------------------

	function getNavbarOffset() {
		return 250;
	}

	window.scrollToAnchor = function (aid) {
		var $target = $("a[name='" + aid + "']");
		if (!$target.length) {
			$target = $('#' + aid);
		}
		if ($target.length) {
			var offsetTop = $target.offset().top - getNavbarOffset();
			$('html, body').animate({ scrollTop: Math.max(0, offsetTop) }, 800);
		}
	};

	// Smooth scroll to anchor links on the same page
	$(document).on(
		'click',
		'a[href*="#"]:not([href="#"]):not([href="#0"]):not(.skip-link):not([data-bs-toggle])',
		function (e) {
			if (
				location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
				location.hostname === this.hostname
			) {
				var hash = this.hash;
				var $target = $(hash);
				if (!$target.length) {
					$target = $('[name=' + hash.slice(1) + ']');
				}
				if ($target.length) {
					e.preventDefault();
					var targetOffset = $target.offset().top - getNavbarOffset();
					if (window.history && window.history.pushState) {
						window.history.pushState(null, null, hash);
					} else {
						window.location.hash = hash;
					}
					$('html, body').animate(
						{
							scrollTop: Math.max(0, targetOffset),
						},
						600
					);
				}
			}
		}
	);

	// Handle initial URL hash on page load
	$(document).ready(function () {
		if (window.location.hash) {
			var initialHash = window.location.hash;
			var $initialTarget = $(initialHash);
			if (!$initialTarget.length) {
				$initialTarget = $('[name=' + initialHash.slice(1) + ']');
			}
			if ($initialTarget.length) {
				setTimeout(function () {
					var initialOffset = $initialTarget.offset().top - getNavbarOffset();
					$('html, body').animate(
						{
							scrollTop: Math.max(0, initialOffset),
						},
						400
					);
				}, 300);
			}
		}
	});

	// -----------------------------------------------------------------
	// Collapse Navbar
	// -----------------------------------------------------------------

	var didScroll = true;
	var lastScrollTop = 0;
	var delta = 5;
	var notiHeight = $('.njt-nofi-notification-bar').outerHeight();
	notiHeight = notiHeight == undefined ? 0 : notiHeight;

	// Top position of the navbar
	var offset = $('.d--intro-navbar').length ? $('.d--intro-navbar').offset() : { top: 0 };

	$(window).scroll(function (event) {
		didScroll = true;
	});

	setInterval(function () {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	function hasScrolled() {
		var st = $(window).scrollTop();

		// Make sure they scroll more than delta
		if (Math.abs(lastScrollTop - st) <= delta) return;

		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > offset.top) {
			// Scroll Down
			$('.d--intro-navbar').addClass('d--sticky');
		} else {
			// Scroll Up
			if (st < offset.top - delta) {
				$('.d--intro-navbar').removeClass('d--sticky');
			}
		}

		if (st < offset.top) {
			$('.d--intro-navbar').removeClass('d--sticky');
		}

		lastScrollTop = st;
	}

	// -----------------------------------------------------------------
	// Link & button events
	// -----------------------------------------------------------------

	// Show search overlay
	$('.d--link-search').on('click', function (e) {
		e.preventDefault();
		jQuery('#d--modal-search').modal('show');
		jQuery('#d--modal-search .form-control').val('');
		setTimeout(function () {
			jQuery('#d--modal-search .form-control').focus();
		}, 1000);
	});

	// Show menu overlay
	$('.d--link-menu').on('click', function (e) {
		e.preventDefault();
		jQuery('#d--modal-menu').modal('show');
	});

	// Change url between "Demeter-Welt" and "Mitglieder" based on menu dropdown.
	$('#d--select-nav-menu').on('change', function () {
		var domain = window.location.origin + '/';
		var pathArray = window.location.pathname.split('/');

		//alert("value: " + this.value + " / 0: " + pathArray[0] + " / 1: " + pathArray[1]);
		// Demeter-Welt => Mitglieder: mitglieder/''/''
		// Mitglieder => Demeter-Welt: demeter-welt/''/mitglieder
		// Monde-Demeter => Membres: mitglieder/''/fr
		// Membres => Monde-Demeter: demeter-welt/''/fr

		if (this.value === 'mitglieder' && (pathArray[1] === '' || pathArray[1] !== 'fr')) {
			window.location.href = domain + "mitglieder/";
		}
		else if (this.value === 'mitglieder' && pathArray[1] === 'fr') {
			window.location.href = domain + "fr/membres/";
		}
		else if (this.value === 'demeter-welt' && pathArray[1] === 'mitglieder') {
			window.location.href = domain;
		}
		else if (this.value === 'demeter-welt' && pathArray[1] === 'fr') {
			window.location.href = domain + "fr/";
		}


		// Only change if we are not already in this section
		/*
		if (this.value === 'mitglieder') {
			if (pathArray[0] !== 'mitglieder') {
				window.location.href = domain + "mitglieder/";
			} else {
				// Reset Selection
				$('#d--select-nav-menu').val("demeter-welt").change();
			}
		} else {
			if (pathArray[0] !== 'demeter-welt') {
				window.location.href = domain;
			} else {
				// Reset Selection
				$('#d--select-nav-menu').val("mitglieder").change();
			}
		}
		*/
	});

	// -----------------------------------------------------------------
	// Dropdown depth 3 fix
	// -----------------------------------------------------------------
	/*$('.navbar-nav .dropdown > a').click(function (e) {
		// First level dropdown link in nav
		// location.href = this.href;
		e.preventDefault();
		return false;
	});*/

	$('.dropdown-menu > li > .dropdown-menu').parent().addClass('dropdown-submenu').find(' > .dropdown-item').addClass('dropdown-toggle');

	$('.dropdown-submenu > a').on('mouseover', function () {
		var dropdown = $(this).parent().find(' > .show');
		$('.dropdown-submenu .dropdown-menu').not(dropdown).removeClass('show');
		$(this).next('.dropdown-menu').toggleClass('show');
	});

	$('.dropdown-submenu > a').on('mouseout', function () {
		var dropdown = $(this).parent().find(' > .show');
		$('.dropdown-submenu .dropdown-menu').removeClass('show');
		//$(this).next('.dropdown-menu').toggleClass('show');
	});

	$('.dropdown-submenu > a').on('click', function () {
		var dropdown = $(this).parent().find(' > .show');
		$('.dropdown-submenu .dropdown-menu').not(dropdown).removeClass('show');
		$(this).next('.dropdown-menu').toggleClass('show');
	});

	// hide all open menus if the parent closes
	$('.dropdown').on('hidden.bs.dropdown', function () {
		$('.dropdown-menu.show').removeClass('show');
	});

	// -----------------------------------------------------------------
	//  Newsletter form
	// -----------------------------------------------------------------

	// Validate email address.
	function validateEmail(email) {
		const regex_pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regex_pattern.test(email);
	}

	// Submit nl-form on enter.
	$('#d--nl-short #inputEmail').on('keypress', function(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			$('#nl-form-short-submit').trigger('click');
		}
	});

	// Footer newsletter form
	$('#nl-form-submit').on('click', function (e) {
		e.preventDefault();
		var flag = false;
		// Set form id
		const ID = $(this).closest('form').attr('id');
		const formID = '#' + ID;

		// Debug.
		// console.log('clicked #nl-form-submit');
		// console.log('----------');
		// console.log('Send form: ' + formID);

		let firstname = $('#inputFirstname').val();
		let lastname = $('#inputLastname').val();
		let email = $('#inputEmail').val();

		if (firstname.length === 0) {
			$('#inputFirstname').addClass('error');
			setFormStatus(formID, 'invalid');
		} else {
			$('#inputFirstname').removeClass('error');
		}
		if (lastname.length === 0) {
			$('#inputLastname').addClass('error');
			setFormStatus(formID, 'invalid');
		} else {
			$('#inputLastname').removeClass('error');
		}

		if (!validateEmail(email)) {
			$('#inputEmail').addClass('error');
			setFormStatus(formID, 'invalid');
		} else {
			$('#inputEmail').removeClass('error');
		}

		if (firstname.length > 0 && lastname.length > 0 && validateEmail(email)) {
			// Debug.
			// console.log('Ready to submit');

			resetFormStatus();
			$(formID).submit();
		}
	});

	// -----------------------------------------------------------------
	// Validation
	// -----------------------------------------------------------------

	/**
	 * Check form validation
	 *
	 * @param {*} id Form id
	 * @returns bool  Returns 'true' if valid or 'false' if not
	 */
	function checkValidation(id) {
		var flag = true;

		// Reset old status message
		resetFormStatus();

		// Build map of form fields
		const forms = document.querySelectorAll(id);
		var form = forms[0];

		if (!form.checkValidity()) {
			// Form not valid
			flag = false;
			setFormStatus(id, 'invalid');
		}

		form.classList.add('was-validated');

		// console.log('checkValidation: ' + flag);
		return flag;
	}

	/**
	 * Reset form data
	 * This.reset(); Should be called directly, sometimes we like to see the alerts...
	 *
	 * @param {string} id Form id
	 */
	function resetForm(id) {
		$(id).trigger('reset');
		$(id).removeClass('was-validated');

		$(id + ' :input:not([type=hidden])').val('');
		$(id + ' select').val('');
		$(id + ' textarea').val('');
		$(id + ' input:checkbox').removeAttr('checked');

		// Todo: Custom displays must also be reseted
	}

	/**
	 * Reset form status message
	 */
	function resetFormStatus() {
		// Debug.
		// console.log('resetFormStatus');
		$('.d--form-status .alert').hide();
	}

	/**
	 * Set form status message
	 *
	 * @param {*} id Form id
	 * @param {*} kind 'success', 'invalid' or 'error'
	 * @param {*} msg Status message (optional)
	 */
	function setFormStatus(id, kind, msg) {
		resetFormStatus();

		// Debug.
		// console.log('setFormStatus: ' + kind);
		// console.log('setFormStatus Message: ' + msg);

		if (kind) {
			if (msg) {
				$(id + ' .d--alert-' + kind).html(msg);
			}
			$(id + ' .d--alert-' + kind).show();
		}
	}

	// -----------------------------------------------------------------
	// Legal form check box
	// -----------------------------------------------------------------

	// Legal checkbox 'change' event
	$('.d--cb-legal').change(function () {
		// console.log('Legal checkbox clicked...');

		if (this.checked) {
			$(this).prop('checked', this.checked);
		}
		$(this).val(this.checked);

		enableSubmitButtonStatus('#form-submit', this.checked);
		enableSubmitButtonStatus('#nl-form-submit', this.checked);
		enableSubmitButtonStatus('#d--btn-submit', this.checked);
		enableSubmitButtonStatus('#d--btn-form-submit', this.checked);
	});

	/**
	 * NL legal checkbox 'change' event
	 */
	$('input[name="_mc4wp_subscribe_contact-form-7"]').change(function () {
		if (this.checked) {
			$(this).prop('checked', this.checked);
		}
		$(this).val(this.checked);

		enableSubmitButtonStatus('#form-submit', this.checked);
	});

	var legal_advertising = false;
	var legal_copyright = false;
	var legal_correction = false;

	$('.d--cb-legal-advertising').change(function () {
		legal_advertising = false;
		if (this.checked) {
			$(this).prop('checked', this.checked);
			legal_advertising = true;
		}
		$(this).val(this.checked);

		enableExtendedSubmitButtonStatus();
	});

	$('.d--cb-legal-copyright').change(function () {
		legal_copyright = false;
		if (this.checked) {
			$(this).prop('checked', this.checked);
			legal_copyright = true;
		}
		$(this).val(this.checked);

		enableExtendedSubmitButtonStatus();
	});

	$('.d--cb-legal-correction').change(function () {
		legal_correction = false;
		if (this.checked) {
			$(this).prop('checked', this.checked);
			legal_correction = true;
		}
		$(this).val(this.checked);

		enableExtendedSubmitButtonStatus();
	});

	// ---------------------------------------------------------
	// Enable/Disable form submit button
	// ---------------------------------------------------------

	/**
	 * Enable/Disable submit button
	 *
	 * @param {*} id Button id
	 * @param {*} bool Enabled 'true' or 'false'
	 */
	function enableSubmitButtonStatus(id, bool) {
		$(id).prop('disabled', !bool);
	}

	function enableExtendedSubmitButtonStatus() {
		var flag = false;
		if (legal_advertising && legal_copyright && legal_correction) {
			flag = true;
		}
		enableSubmitButtonStatus('#d--btn-form-submit', flag);
	}

	// Disable form submit button initially.
	$('#d--btn-form-submit').prop('disabled', true);

	// -----------------------------------------------------------------
	// Form submit button
	// -----------------------------------------------------------------

	// On nl form submit button 'click' event.
	$('#d--nl-full #d--btn-form-submit').on('click', function (e) {
		// Stop the default form submit
		e.preventDefault();

		// Set form id
		var formID = '#d--nl-full';

		// Debug.
		// console.log('----------');
		// console.log('Send form: ' + formID);

		// Validate form fields
		if (!checkValidation(formID)) {
			// console.log('Validation failed!');
			return false;
		}
		// console.log('Validation successful');

		// Send form data
		sendAjax(this, formID);
	});

	// On advertising form submit button 'click' event.
	$('#d--form-advertising #d--btn-form-submit').on('click', function (e) {
		// Stop the default form submit
		e.preventDefault();

		// Set form id
		var formID = '#d--form-advertising';

		// Debug.
	    // console.log('----------');
		// console.log('Send form: ' + formID);

		// Validate form fields
		if (!checkValidation(formID)) {
			// console.log('Validation failed!');
			return false;
		}
		// console.log('Validation successful');

		// Send form data
		sendAjax(this, formID);
	});

	// On event form submit button 'click' event.
	$('#d--form-event #d--btn-form-submit').on('click', function (e) {
		// Stop the default form submit
		e.preventDefault();
		
		// Set form id
		var formID = '#d--form-event';

		const startSingle = document.getElementById('inputDateStart');
		const startMulti = document.getElementById('inputDateStartWithEnd');
		const endDate = document.getElementById('inputDateEnd');
		const deadline = document.getElementById('inputDeadline');

		const startDate =
			(startMulti && startMulti.offsetParent !== null)
				? startMulti
				: startSingle;

		// Reset custom validation.
		if (deadline) {
			deadline.setCustomValidity('');
		}
		if (endDate) {
			endDate.setCustomValidity('');
		}

		// Deadline must be before start date (only if deadline is entered).
		if (
			deadline &&
			deadline.value &&
			startDate &&
			startDate.value &&
			deadline.value >= startDate.value
		) {
			deadline.setCustomValidity('Anmeldeschluss muss vor dem Startdatum liegen.');
		}

		// If set, end date must be after start date.
		if (
			endDate &&
			endDate.offsetParent !== null &&
			endDate.value &&
			endDate.value <= startDate.value
		) {
			endDate.setCustomValidity('Enddatum muss nach dem Startdatum liegen.');
		}

		// Recalculate
		if (deadline) {
			deadline.checkValidity();
		}
		if (endDate) {
			endDate.checkValidity();
		}

		// Validate form fields
		if (!checkValidation(formID)) {
			// console.log('Validation failed!');
			return false;
		}
		// console.log('Validation successful');

		// Send form data
		sendAjax(this, formID);
	});

	// On default form submit button 'click' event.
	$('#d--btn-submit').on('click', function (e) {
		// Stop the default form submit
		e.preventDefault();

		// Set form id
		var ID = $(this).closest('form').attr('id');
		var formID = '#' + ID;

		// Debug.
		// console.log('----------');
		// console.log('Send form: ' + formID);

		// Validate form fields
		if (!checkValidation(formID)) {
			// console.log('Validation failed!');
			return false;
		}
		// console.log('Validation successful');

		// Send form data
		sendAjax(this, formID);
	});

	function addLoaderclass(btn) {
		console.log('called addLoaderclass for: ' + btn);
		$(btn).addClass('btn-loading-light');
		
		// setTimeout(function () {
		// 	removeLoaderclass(btn);
		// }, 4000);
	}

	function removeLoaderclass(btn) {
		console.log('called removeLoaderclass for: ' + btn);
		$(btn).removeClass('btn-loading-light');
	}
	// ---------------------------------------------------------
	// AJAX
	// ---------------------------------------------------------

	/**
	 * Resize image before upload to optimize transfer speed and server memory usage.
	 * 
	 *
	 * @param {File} file Original file.
	 * @param {number} maxDimension Maximum width/height in pixels.
	 * @param {number} quality JPEG compression quality (0-1).
	 * @return {Promise<File>} Optimized file or original non-image file.
	 */
	function resizeImageBeforeUpload(file, maxDimension, quality) {
		maxDimension = typeof maxDimension !== 'undefined' ? maxDimension : 1920;
		quality = typeof quality !== 'undefined' ? quality : 0.85;

		return new Promise(function (resolve) {
			// Pass through non-image files (e.g. PDF flyers) without modification.
			if (!file || !file.type || !file.type.match(/image.*/)) {
				resolve(file);
				return;
			}

			// Don't resize SVGs or GIFs to avoid breaking animations or vectors.
			if (file.type === 'image/svg+xml' || file.type === 'image/gif') {
				resolve(file);
				return;
			}

			var reader = new FileReader();
			reader.onload = function (readerEvent) {
				var image = new Image();
				image.onload = function () {
					var width = image.width;
					var height = image.height;

					// If image is already smaller than maxDimension and size < 1MB, keep original.
					if (width <= maxDimension && height <= maxDimension && file.size < 1048576) {
						resolve(file);
						return;
					}

					if (width > height) {
						if (width > maxDimension) {
							height = Math.round((height * maxDimension) / width);
							width = maxDimension;
						}
					} else {
						if (height > maxDimension) {
							width = Math.round((width * maxDimension) / height);
							height = maxDimension;
						}
					}

					var canvas = document.createElement('canvas');
					canvas.width = width;
					canvas.height = height;

					var ctx = canvas.getContext('2d');
					ctx.drawImage(image, 0, 0, width, height);

					canvas.toBlob(
						function (blob) {
							if (!blob) {
								resolve(file);
								return;
							}
							var resizedFile = new File([blob], file.name, {
								type: 'image/jpeg',
								lastModified: Date.now(),
							});
							resolve(resizedFile);
						},
						'image/jpeg',
						quality
					);
				};
				image.onerror = function () {
					resolve(file);
				};
				image.src = readerEvent.target.result;
			};
			reader.onerror = function () {
				resolve(file);
			};
			reader.readAsDataURL(file);
		});
	}

	/**
	 * Send ajax data
	 *
	 * @param {string} btn Button id
	 * @param {string} id Form is
	 */
	async function sendAjax(btn, id) {
		addLoaderclass(btn);
		// Get form action & data.
		const action = $(id).attr('action');
		const formElement = $(id)[0];

		// Changed to FormData to support file uploads.
		var data = new FormData(formElement);
		data.append('action', action);

		// Optimize images before upload to speed up transmission and server processing.
		if (formElement) {
			const fileInputs = formElement.querySelectorAll('input[type="file"]');
			for (let i = 0; i < fileInputs.length; i++) {
				const input = fileInputs[i];
				if (input.files && input.files.length > 0) {
					data.delete(input.name);
					for (let j = 0; j < input.files.length; j++) {
						const file = input.files[j];
						const optimizedFile = await resizeImageBeforeUpload(file, 1920, 0.85);
						data.append(input.name, optimizedFile, file.name);
					}
				}
			}
		}

		$.ajax({
			type: 'POST',
			dataType: 'json',
			url: '/wp-admin/admin-ajax.php',
			data: data,
			async: true,
			cache: false,
			contentType: false,
			processData: false,
			timeout: 60000,
			beforeSend: function (data) {
				// Disable submit button.
				enableSubmitButtonStatus(btn, false);
			},
			success: function (data, status, xhr) {
				// Reset form & enable submit button.
				resetForm(id);
				resetFormStatus();

				if (0 === parseInt(data.error)) {
					setFormStatus(id, 'success', '');
					removeLoaderclass(btn);
					// Reload after 10000 ms.
					setTimeout(function () {
						window.location.reload();
					}, 10000);
				} else {
					setFormStatus(id, 'failed', '');
				}
			},
			error: function (jqXHR, status, errorThrown) {
				// Reset form & enable submit button.
				resetFormStatus();
				removeLoaderclass(btn);
				enableSubmitButtonStatus(btn, true);
				setFormStatus(id, 'failed', '');
			},
		});
	}

	// ---------------------------------------------------------
	// Share page on social media
	// ---------------------------------------------------------

	// On click of share button.
	$(document).on('click', '.d--share-icon', function (e) {
		e.preventDefault();
		var $btn = $(this);
		var service = $btn.data('service');
		var url = $btn.data('url') || '';
		var message = $btn.data('message') || '';
		var hashtag = $btn.data('hashtag') || '';
		var title = $btn.data('title') || '';
		var subject = $btn.data('subject') || '';
		var via = $btn.data('via') || '';

		switch (service) {
			case 'facebook':
				shareOnFacebook(url, hashtag);
				break;
			case 'twitter':
				shareOnTwitter(url, message, hashtag, via);
				break;
			case 'linkedin':
				shareOnLinkedin(url, title);
				break;
			case 'whatsapp':
				shareOnWhatsApp(url, message);
				break;
			case 'mail':
				shareOnMail(subject, message);
				break;
			case 'copy':
				copyToClipboard(url);
				break;
		}
	});

	// Open a new window in the middle of the screen.
	window.socialWindow = function (url) {
		var left = (screen.width - 570) / 2;
		var top = (screen.height - 570) / 2;
		var params = 'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left;
		window.open(url, 'NewWindow', params);
		return true;
	};

	// Share on mail
	window.shareOnMail = function (subject, body) {
		var data = 'mailto:?&subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
		window.location.href = data;
	};

	// Share on Facebook
	window.shareOnFacebook = function (url, hashtag) {
		// https://www.facebook.com/sharer/sharer.php?u=https://dctrl.ch
		url = encodeURIComponent(url);
		hashtag = encodeURIComponent(hashtag);
		var data = 'https://www.facebook.com/sharer/sharer.php?u=' + url + '&hashtag=' + hashtag;
		socialWindow(data);
	};

	// Share on Linkedin
	window.shareOnLinkedin = function (url, title) {
		// https://www.linkedin.com/shareArticle?mini=true&url=https://dctrl.ch
		// https://www.linkedin.com/sharing/share-offsite/?url=http%3A%2F%2Fwww.codexworld.com%2Fsocial-popup-page-scroll-using-jquery-css%2F
		url = encodeURIComponent(url);
		title = encodeURIComponent(title);
		var data = 'https://www.linkedin.com/sharing/share-offsite/?url=' + url; // + '&title=' + title;
		socialWindow(data);
	};

	// Share on Pinterest
	window.shareOnPinterest = function (url, media, description) {
		// https://pinterest.com/pin/create/button/?url=https://dctrl.ch&media=&description=Hello%20World
		var e = document.createElement('script');
		e.setAttribute('type', 'text/javascript');
		e.setAttribute('charset', 'UTF-8');
		e.setAttribute('src', 'http://assets.pinterest.com/js/pinmarklet.js?r=' + Math.random() * 99999999);
		document.body.appendChild(e);

		return false;
	};

	// Share on Twitter
	window.shareOnTwitter = function (url, message, hashtags, via) {
		// https: //twitter.com/intent/tweet?url=https://dctrl.ch&text=Hello%20World
		// https://twitter.com/share?url=https://simplesharebuttons.com&amp;text=Simple%20Share%20Buttons&amp;hashtags=simplesharebuttons
		url = encodeURIComponent(url);
		message = encodeURIComponent(message);
		hashtags = encodeURIComponent(hashtags);
		via = encodeURIComponent(via);
		var data = 'https://twitter.com/intent/tweet?text=' + message + '&amp;url=' + url + '&amp;via=' + via + '&amp;hashtags=' + hashtags;
		socialWindow(data);
	};

	// Share on WhatsApp
	window.shareOnWhatsApp = function (url, message) {
		url = encodeURIComponent(url);
		message = encodeURIComponent(message);
		var data = 'https://wa.me/?text=' + message + ' ' + url;
		socialWindow(data);
	};

	// ---------------------------------------------------------
	// Copy data to clipboard
	// ---------------------------------------------------------
	window.copyToClipboard = function (dataString) {
		const tmpInput = document.createElement('input');
		document.body.append(tmpInput);
		const editable = tmpInput.contentEditable;
		const readOnly = tmpInput.readOnly;
		tmpInput.value = dataString;
		tmpInput.contentEditable = true;
		tmpInput.readOnly = false;

		if (isiOS()) {
			var range = document.createRange();
			range.selectNodeContents(tmpInput);
			var selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);
			tmpInput.setSelectionRange(0, 999999);
		} else {
			// The next 2 lines are basically doing the same in different ways (just to be sure)
			navigator.clipboard.writeText(dataString);
			tmpInput.select();
		}

		tmpInput.contentEditable = editable;
		tmpInput.readOnly = readOnly;
		document.execCommand('copy');
		tmpInput.remove();

		$('#d--toast-success').toast('show');
	};

	// Check if we are in a browser environment.
	window.isBrowser = function () {
		if (typeof window === 'undefined') {
			return false;
		} else {
			return true;
		}
	};

	// Check if we are on an iOS device.
	window.isiOS = function () {
		if (isBrowser) {
			if ((/iPad|iPhone|iPod/i.test(navigator.userAgent || navigator.vendor || window.opera) && !window.MSStream) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	};
})(window.jQuery);

// ---------------------------------------------------------
// Show toast
// ---------------------------------------------------------
window.showToast = function () {
	var myAlert = document.getElementById('toastNotice'); //select id of toast
	var bsAlert = new bootstrap.Toast(myAlert);
	bsAlert.show();
};

// ---------------------------------------------------------
// Init AOS scroll animation
// ---------------------------------------------------------
window.AOS.init({
	disable: 'mobile',
});
